<template>
  <b-modal
    title="Add Seed"
    ref="add-seed-modal"
    id="add-seed-modal"
    size="lg"
    ok-title="Add"
    @ok="addSeed"
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <validation-observer ref="addSeedRule" tag="form">
        <b-form-group label-for="subject">
          <div style="display:inline-block; width: 10%;">SUBJECT<span class="text-danger">*</span></div>
          <validation-provider
            #default="{ errors }"
            name="Subject"
            rules="required"
          >
          <b-form-input
            id="subject_kor"
            v-model="seed.subjectKor"
            placeholder="주제(한글)"
            style="display:inline-block; width:43%; margin-left:1rem;"
            :state="errors.length > 0 ? false : null"
          />
          <b-form-input
            id="subject_eng"
            v-model="seed.subjectEng"
            placeholder="주제(영어)"
            style="display:inline-block; width:43%; margin-left:1rem;"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group label-for="topic1">
          <div style="display:inline-block; width: 10%;">TOPIC1</div>
            <b-form-input
              id="topic1_kor"
              v-model="seed.topic1Kor"
              placeholder="토픽1(한글)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="topic1_eng"
              v-model="seed.topic1Eng"
              placeholder="토픽1(영어)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="topic2">
          <div style="display:inline-block; width: 10%;">TOPIC2</div>
            <b-form-input
              id="topic2_kor"
              v-model="seed.topic2Kor"
              placeholder="토픽2(한글)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="topic2_eng"
              v-model="seed.topic2Eng"
              placeholder="토픽2(영어)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="category">
          <div style="display:inline-block; width: 10%;">CATEGORY</div>
            <b-form-input
              id="category_kor"
              v-model="seed.categoryKor"
              placeholder="카테고리(한글)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="category_eng"
              v-model="seed.categoryEng"
              placeholder="카테고리(영어)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="brand">
          <div style="display:inline-block; width: 10%;">BRAND</div>
            <b-form-input
              id="brand_kor"
              v-model="seed.brandKor"
              placeholder="브랜드(한글)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="brand_eng"
              v-model="seed.brandEng"
              placeholder="카테고리(영어)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="line">
          <div style="display:inline-block; width: 10%;">LINE</div>
            <b-form-input
              id="line_kor"
              v-model="seed.lineKor"
              placeholder="라인명(한글)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="line_eng"
              v-model="seed.lineEng"
              placeholder="라인명(영어)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="product">
          <div style="display:inline-block; width: 10%;">PRODUCT</div>
            <b-form-input
              id="product_kor"
              v-model="seed.productKor"
              placeholder="상품명(한글)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="product_eng"
              v-model="seed.productEng"
              placeholder="상품명(영어)"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>



      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import CISSettingService from '@/services/cis-setting.service'

export default {
  name: "AddSeedModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      roles: [],
      seed: {},
      required,
    };
  },
  watch: {
    
  },
  methods: {
    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.addSeedRule.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject("The Subject field is required");
          }
        });
      });
    },
    async addSeed(e) {
      e.preventDefault();
      await this.checkInfo();

      this.$swal({
        title: "Are you sure?",
        html: `You want to add the Seed!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {
          var ctgSq = this.$store.getters.getSelectedCategory
          if(ctgSq == '9999'){
            ctgSq = 1
          }
          this.seed.ctgSq = ctgSq
          const response = await CISSettingService.addSeed(this.seed);
          if (response && response.status === 200) {
            this.seed = {};
            this.$bvModal.hide("add-seed-modal");
            this.refreshData();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully added!`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
  },
  created() {
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>